import PropTypes from "prop-types";

// material-ui
import { useColorScheme } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

// project imports
import { ThemeMode } from "config";

// constant
const headerStyle = {
  "& .MuiCardHeader-action": {
    mr: 0,
    width: { xs: "100%", sm: "auto" },
    mt: { xs: 1, sm: 0 },
  },
  "& .MuiCardHeader-content": {
    width: { xs: "100%", sm: "auto" },
  },
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "flex-start", sm: "center" },
};

export default function MainCard({
  border = false,
  boxShadow,
  children,
  content = true,
  contentClass = "",
  contentSX = {},
  headerSX = {},
  darkTitle,
  secondary,
  shadow,
  sx = {},
  title,
  ref,
  ...others
}) {
  const { colorScheme } = useColorScheme();
  const defaultShadow =
    colorScheme === ThemeMode.DARK
      ? "0 2px 14px 0 rgb(33 150 243 / 10%)"
      : "0 2px 14px 0 rgb(32 40 45 / 8%)";

  return (
    <Card
      ref={ref}
      {...others}
      sx={(theme) => ({
        border: border ? "1px solid" : "none",
        borderColor: "divider",
        ":hover": {
          boxShadow: boxShadow ? shadow || defaultShadow : "inherit",
        },
        ...(typeof sx === "function" ? sx(theme) : sx || {}),
      })}
    >
      {/* card header and action */}
      {!darkTitle && title && (
        <CardHeader
          sx={{ ...headerStyle, ...headerSX }}
          title={title}
          action={secondary}
        />
      )}
      {darkTitle && title && (
        <CardHeader
          sx={{ ...headerStyle, ...headerSX }}
          title={<Typography variant="h3">{title}</Typography>}
          action={secondary}
        />
      )}

      {/* content & header divider */}
      {title && <Divider />}

      {/* card content */}
      {content && (
        <CardContent sx={contentSX} className={contentClass}>
          {children}
        </CardContent>
      )}
      {!content && children}
    </Card>
  );
}

MainCard.propTypes = {
  border: PropTypes.bool,
  boxShadow: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.bool,
  contentClass: PropTypes.string,
  contentSX: PropTypes.object,
  headerSX: PropTypes.object,
  darkTitle: PropTypes.bool,
  secondary: PropTypes.any,
  shadow: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  ref: PropTypes.object,
  others: PropTypes.any,
};
